import {env} from '@/config';
import axios from 'axios';
const {MATRIX_SERVER_URL_SUFFIX} = env;

let exchangeSsoTokenPromise: Promise<{
  accessToken: string;
  userId: string;
  deviceId: string;
}> | null = null;
export const exchangeSsoToken = async (
  ssoToken: string
): Promise<{accessToken: string; userId: string; deviceId: string}> => {
  if (!exchangeSsoTokenPromise) {
    exchangeSsoTokenPromise = (async () => {
      try {
        const txn_id = Math.random().toString(36).substring(2, 11);
        const response = await axios.post(
          `https://${MATRIX_SERVER_URL_SUFFIX}/_matrix/client/r0/login`,
          {
            type: 'm.login.token',
            token: ssoToken,
            txn_id: txn_id
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        const data = response.data;

        return {
          accessToken: data.access_token,
          userId: data.user_id,
          deviceId: data.deviceId
        };
      } catch (error) {
        console.error('Error while exchanging token', error);
        throw error;
      }
    })();
    exchangeSsoTokenPromise.finally(() => {
      exchangeSsoTokenPromise = null;
    });
  }
  return new Promise((resolve, reject) => {
    exchangeSsoTokenPromise?.then(resolve).catch(reject);
  });
};
